import { render, staticRenderFns } from "./VehicleFormDialog.vue?vue&type=template&id=573f1a22&scoped=true"
import script from "./VehicleFormDialog.vue?vue&type=script&lang=js"
export * from "./VehicleFormDialog.vue?vue&type=script&lang=js"
import style0 from "./VehicleFormDialog.vue?vue&type=style&index=0&id=573f1a22&prod&scoped=true&lang=css"
import style1 from "./VehicleFormDialog.vue?vue&type=style&index=1&id=573f1a22&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573f1a22",
  null
  
)

export default component.exports